import {
    IonButton, IonCheckbox, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonPage,
    IonRow,
    IonText,
    useIonViewWillEnter
} from "@ionic/react";
import { useState } from "react";
import { useHistory, useLocation } from "react-router";

import { Link } from "react-router-dom";
import Footer from "../../../components/Footer";
import UserTerms from "../../../components/UserTerms";
import { User } from "../../../models/data";
import { translation } from "../../../models/translation";

interface Props {
    user: User
}


interface DonateForm {
    pickOrg: string | null,
    altOrg: string | null,
    date: string,
    freq: string,
    message: string | null,
    amount: number,
    language:string,
    tip:number,
    anom: boolean,
    beneficiary_type: string
}
const DonateGift: React.FC<Props> = ({user}) => {

    const history = useHistory();

    const location = useLocation()

    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const [state]:any= useState(()=>{return location.state})
    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;

    const tips = [
  
        {
            name: 'middle',
            value: 0.05,
            label: '5%'
        },
       
    ]

    const [tip] = useState<number>(() => {
        return tips[0].value
    });

    const [amount, setAmount] = useState(() => { return 0 })
    const [orgChoice, setOrgChoice] = useState({
        pickOrg: 'giftcard',
    });

    const [donateData, setDonateData] = useState<DonateForm>({
        pickOrg: null,
        altOrg: null,
        date: minDate,
        freq: 'single',
        language:lan,
        amount: 0,
        tip:0,
        anom: false,
        beneficiary_type: "giftcard",
        message:null
    })

 


    const [terms, agreeTerms] = useState(false);

    const [userTerms, showUserTerms] = useState<boolean>(false);

    

    useIonViewWillEnter(() => {
        if(state && state.gifting){
            setGiftData()
            setOrgChoice({pickOrg: 'giftcard'})
            return
        }else{
            history.push(`/${lan}/account/giftCard`)
        }
    }, [state])

    const setGiftData=()=>{
        let form = donateData;
            form.pickOrg = '382';
            form.beneficiary_type = "giftcard";
            form.altOrg = `Name: ${state.fName}, last Name: ${state.name} ,e-mail ${state.email}`;
            form.message= state.message;
            setDonateData(form);

    }

    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }
    const commissionToCash = (value: any) => {
        let tip = amount * value
        tip = Math.round(tip * 100) / 100
        return tip
    }

    const amountSummary = (amount: any, tip: any) => {
        let summary = +amount + (amount * tip)
        summary = Math.round(summary * 100) / 100
        return summary
    }

    const onSubmit = (event: any) => {
        event.preventDefault();
        if (!amount) return
        donateData.amount = (+amount + (amount * tip))
        //added tip field
        donateData.tip=tip*amount
        let donationState = {
            data: donateData
        }
        history.push(`/${lan}/account/donate_process_V2`, donationState);


    }
    return (
        <IonPage>
            <IonContent>

                {!userTerms ?
                    <IonGrid className="innerBody">
                        <IonRow >
                            <IonCol className="ion-margin-top" offsetSm="1" sizeSm="10" sizeMd="8">
                                <h1 className="h2">{siteText.giftFormPageTitle}</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow className="ion-margin-bottom">
                            <IonCol className="ion-margin-top" offsetSm="1" sizeSm="10" sizeMd="8">
                                <form onSubmit={e => onSubmit(e)}>

                                    <IonLabel position="stacked">{siteText.giftFormPageAmountLabel}</IonLabel>
                                    <IonInput className="ion-margin-bottom ion-margin-top" value={amount} onIonChange={(e: any) => setAmount(+e.detail.value)} placeholder={siteText.donateDirectlyStartAmountPlh} min="0" type="number"></IonInput>
                                    <h4>{siteText.giftFormPageSubtotalText} {amount ? amountSummary(amount, tip) : 0} CHF</h4>

                                    {tips.map((m, key) => <IonItem className="ion-margin-end" lines="none" key={key}><IonLabel className="ion-margin-end">{siteText.giftFormPageFeeText} {+(m.value)*100} % : {commissionToCash(m.value)} CHF</IonLabel> </IonItem>)}

                                
                                    {
                                        (orgChoice.pickOrg === 'giftcard')
                                            ? (<>
                                                {(state && state.gifting) && 
                                                <>
                                                <IonLabel position="stacked">{siteText.donateGiftLabel}</IonLabel>
                                                <IonInput disabled className="ion-margin-bottom ion-margin-top" value={`${state.fName} ${state.name}`} required={(orgChoice.pickOrg === "giftcard") ? true : false}></IonInput>
                                                </>

                                                }
                                                
                                            </>)
                                            : ''
                                    }

                                    <IonCol sizeMd="4">
                                        <IonItem lines="none" className="borderedInput ion-margin-bottom">
                                            <IonLabel className="ion-text-wrap"> <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateDirectlypayConfirm}</Link> </IonLabel>
                                            <IonCheckbox slot="start" checked={terms} onIonChange={() => { agreeTerms(!terms) }} />
                                        </IonItem>
                                    </IonCol>
                                    <IonButton disabled={!terms || amount === 0} strong slot="end" className="ion-margin-top" type="submit">
                                        <IonText color="light">
                                            {siteText.donateDirectlyStartSubmitTxt}
                                        </IonText>
                                    </IonButton>
                                </form>
                            </IonCol>
                        </IonRow>
                    </IonGrid> :
                    <IonGrid className="innerBody">
                        <IonRow>
                            <IonCol offsetSm="1" sizeMd="10" sizeSm="10">
                                <UserTerms goBack={toggleUserTerms}></UserTerms>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                }
                <Footer></Footer>
            </IonContent>

        </IonPage>
    )

}

export default DonateGift;